function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isSameMonth } from 'date-fns';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDateUtils } from '../../../../../utils';
import { createActiveMonth, findClosestDateToFocus, getFocusableDate } from '../../utilities';
import { getNextAvailableDay } from '../../utilities/getNextAvailableDay';
import { useDaysUtilities } from './useDaysUtilities';
import { useMonth } from './useMonth';
export var useActiveMonth = props => {
  var _props$selectedDate;

  var {
    createDate
  } = useDateUtils();
  var {
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  } = useDaysUtilities({
    excludeHolidays: props.excludeHolidays,
    minDate: props.minDate,
    maxDate: props.maxDate,
    weekDays: props.weekDays
  });
  var today = createDate();
  var [activeMonth, setActiveMonth] = useState(createActiveMonth((_props$selectedDate = props.selectedDate) !== null && _props$selectedDate !== void 0 ? _props$selectedDate : today));
  var [focusableDate, setFocusableDate] = useState(undefined);
  var [focusedDate, setFocusedDate] = useState(undefined);
  var {
    minDate,
    secondarySelectedDate,
    selectedDate
  } = props;
  var sharedPropsToGetPartialWeeks = useMemo(() => ({
    selectedDate,
    secondarySelectedDate,
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  }), [isAfterMaxDate, isBeforeMinDate, isHoliday, isInWeekDays, secondarySelectedDate, selectedDate]);
  var setAvailableActiveMonth = useCallback(() => {
    if (!minDate || selectedDate && selectedDate >= minDate) return;
    var nextAvailableDay = getNextAvailableDay(_objectSpread(_objectSpread({}, sharedPropsToGetPartialWeeks), {}, {
      activeMonth: createActiveMonth(minDate) // save iterations by setting the `minDate` instead of checking all months from `activeMonth`.

    }));

    if (nextAvailableDay) {
      setActiveMonth(createActiveMonth(nextAvailableDay.date));
    }
  }, [minDate, selectedDate, sharedPropsToGetPartialWeeks]);
  useEffect(() => {
    setAvailableActiveMonth(); // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to run this only on mount
  }, []);
  var {
    month: weeks
  } = useMonth(_objectSpread(_objectSpread({
    activeMonth
  }, props), {}, {
    onSelect: date => {
      props.onSelect(date);
      setActiveMonth(createActiveMonth(date));
      setFocusableDate(date);
    }
  }));
  var defaultFocusableDay = useMemo(() => getFocusableDate(weeks.flat()), [weeks]);
  var getClosestDateToFocus = useCallback(date => {
    var dateToFocus = findClosestDateToFocus(_objectSpread(_objectSpread({}, sharedPropsToGetPartialWeeks), {}, {
      activeMonth,
      focusedDate,
      date,
      weeks
    }));

    if (dateToFocus && activeMonth && !isSameMonth(dateToFocus, activeMonth.date)) {
      setActiveMonth(createActiveMonth(dateToFocus)); // it is important to set the focusable date after changing the active month.

      setFocusableDate(dateToFocus);
    }

    if (dateToFocus) {
      setFocusedDate(dateToFocus);
    }
  }, [sharedPropsToGetPartialWeeks, focusedDate, weeks, activeMonth]);
  return {
    today,
    weeks,
    activeMonth,
    defaultFocusableDay,
    setActiveMonth,
    focusableDate: focusableDate !== null && focusableDate !== void 0 ? focusableDate : defaultFocusableDay,
    setFocusableDate,
    focusedDate,
    setFocusedDate,
    getClosestDateToFocus
  };
};
//# sourceMappingURL=useActiveMonth.js.map